import script from "./TableMixin.vue?vue&type=script&lang=js"
export * from "./TableMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__